import React, { useEffect } from "react"
import { View, ScrollView, StatusBar, Platform } from 'react-native';
import { useSelector, useDispatch } from "react-redux";
import { global, colors } from "../const";
import styles from "../styles";
import Header from "../components/Header";
import * as Actions from "../action";
import Videoplayer from "../components/Videoplayer";
import { PrimaryTitle } from "../components/labels";
import Button from "../components/form/Button";
import localize from "../localize";

WelcomeContainer.navigationOptions = () => {
    return { title: localize.Welcome }
}

export default function WelcomeContainer(props) {
    const dispatch = useDispatch();
    const rg_video = useSelector(({ auth }) => auth.rg_video);

    useEffect(() => {
        if (Platform.OS === "android") {
            StatusBar.setBackgroundColor(colors.midnightBack);
            StatusBar.setBarStyle("light-content");
        }
        dispatch(Actions.getRegisterVideo())
    }, [])


    return (
        <View style={styles.container}>
            {
                !global.isNative && (<Header title={localize.Welcome} goBack={() => props.history.push({ pathname: "/" })} />)
            }
            <StatusBar barStyle="light-content" backgroundColor={colors.midnightBack} />
            <ScrollView style={{ flex: 1, padding: 15 }}>
                <View>
                    <PrimaryTitle>
                        {localize.This_is_where_technology_is_going_to_help_your_family_be_better}
                    </PrimaryTitle>
                    <View style={{ minHeight: 200, marginVertical: 30 }}>
                        {rg_video && (
                            <Videoplayer
                                src={rg_video.video}
                                poster={rg_video.image}
                            />
                        )}
                    </View>
                    <Button
                        title={localize.Next}
                        onPress={() => global.isNative ? props.navigation.navigate("CreateAccount") : props.history.push({ pathname: "/Create-Account" })}
                    />
                </View>
            </ScrollView>
        </View>
    );
}